/***************************************************************************************************
 * APPLICATION IMPORTS
 */
// global is being aliased as window because sockjs calls window as global when bootstrapping -_-
(window as any).global = window;
